/**
 * What the "Forgot your password?" email link carries.
 *
 * Supabase puts the recovery session in the part of the address after the #
 * (access_token, refresh_token, type=recovery). The shared client is built with
 * detectSessionInUrl off, so nothing reads it automatically and the reset
 * screen said "this link no longer works" for a good link. The screen reads it
 * here and hands it to setSession itself.
 *
 * A bad or used link comes back as #error=access_denied&error_code=otp_expired
 * and reads as expired.
 */
export type RecoveryLink =
  | { kind: 'session'; accessToken: string; refreshToken: string }
  | { kind: 'expired' }
  | { kind: 'none' };

export function readRecoveryLink(hash: string): RecoveryLink {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  if (params.get('error') || params.get('error_code')) return { kind: 'expired' };
  const accessToken = params.get('access_token');
  const refreshToken = params.get('refresh_token');
  if (accessToken && refreshToken) return { kind: 'session', accessToken, refreshToken };
  return { kind: 'none' };
}
